import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import ObserverEmitter, { EVENTS } from '../../../emitter/Observer';
import { audiosAssets } from '../../../assets/audio';
import { ButtonHome } from '../../../components/common/ButtonHome';
import { ButtonPlay } from '../../../components/common/ButtonPlay';
import { HeaderRedPresentation } from '../../../components/common/HeaderRedPresentation';
import { DialogBarNew } from '../../../components/common/DialogBarNew';
import { PanelActivities } from '../../../components/common/PanelActivities';
import { BarStatusActivies } from '../../../components/common/BarStatusActivies';
import { ValidationResultModal } from '../../../components/common/ValidationResultModal';
import { useNavigate } from 'react-router-dom';
import { completeOneTask } from '../../../store/slices/menu/tunks';
import { tasksId } from '../../../types/activityTasks';
import { useGetActivitiesBySubTopic } from '../../../hooks/useGetActivitiesBySubTopic';
import { ButtonReturn } from '../../../components/common/ButtonReturn';
import { voicesTypeControl } from '../../../types/audioType';

const steps = {
	dialogInitial: 1,
	panelActivities: 2,
	dialogTwo: 3,
	dialogThree: 4,
	dialogFour: 5,
	dialogFive: 6,
	dialogSix: 7,
	dialogSeven: 8,
	win: 9
};

export const Theme7SubtopicOneActivityOne = () => {
	const navigator = useNavigate()
	const dispatch = useDispatch()
	const { loaded, activitiesInformation } = useSelector((state) => state.menu);
	const { tasksList, points } = useGetActivitiesBySubTopic(activitiesInformation[tasksId.tema7.activities.subtema1], 1);
	const [uiToShow, setUiToShow] = useState(steps.dialogInitial);

	useEffect(() => {
		if (loaded) {
			console.log("theme 7 sub 1 act 1");
			ObserverEmitter.emit(EVENTS.tema7.topic1.initScene, 1);
			ObserverEmitter.emit(EVENTS.audiosEvents.pauseActive, true)
			ObserverEmitter.emit(EVENTS.audiosEvents.createAudioScene, audiosAssets.escenarios.onOxxoScene)
		}
	}, [loaded]);

	ObserverEmitter.on(EVENTS.audioInitByTopic, () => {
		ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a01)
	})

	return (
		<>
			<>
				<ButtonPlay />
				<ButtonHome />
				{![1, -1, -2].includes(uiToShow) && (
					<ButtonReturn callback={() => {
						ObserverEmitter.emit(EVENTS.tema7.topic1.initScene, 1);
						setUiToShow(1)
					}} />
				)}
			</>

			{uiToShow === steps.dialogInitial && (
				<>
					<HeaderRedPresentation name='Actividad 1:  Requisitos esenciales.' />
					<DialogBarNew
						dialog={`Me da gusto que continúes con la capacitación. Ya quedan las ultimas 2 actividades en la Tienda Base.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							ObserverEmitter.emit(EVENTS.characterAnimations.hiddenModel);
							setUiToShow(steps.panelActivities);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.panelActivities && (
				<>
					<PanelActivities
						buttonText="¡Comenzar!"
						title="Subtema 1. Venta Responsable"
						titleActivity="Actividades por realizar:"
						points={points}
						insigniaBackground={0}
						actionButton={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a02)
							ObserverEmitter.emit(EVENTS.characterAnimations.saludo);
							setUiToShow(steps.dialogTwo);
						}}
						activities={tasksList}
					/>
				</>
			)}

			{uiToShow === steps.dialogTwo && (
				<>
					<BarStatusActivies
						activities={tasksList}
					/>
					<DialogBarNew
						dialog={`De acuerdo a tu lista de actividades, te toca aprender sobre la venta responsable.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a03)
							setUiToShow(steps.dialogThree);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogThree && (
				<>
					<DialogBarNew
						dialog={`Te sugiero tomar en cuenta los siguientes consejos para llevar a cabo una venta responsable de alcohol y cigarros.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a04)
							setUiToShow(steps.dialogFour);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFour && (
				<>
					<DialogBarNew
						dialog={`Asegúrate de tener en el portapermisos de tu Tienda la licencia de venta vigente.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a05)
							setUiToShow(steps.dialogFive);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogFive && (
				<>
					<DialogBarNew
						dialog={`Toma los clips referentes a este tema que se encuentre en Universidad FEMSA.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a06)
							setUiToShow(steps.dialogSix);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSix && (
				<>
					<DialogBarNew
						dialog={`Respeta los horarios permitidos de venta.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.createAudioVoiceButton, audiosAssets.voices.voicesGlobal.T7.subtema1.actividad1.sub1a07)
							setUiToShow(steps.dialogSeven);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.dialogSeven && (
				<>
					<DialogBarNew
						dialog={`Niega la venta de cigarros y alcohol a menores de edad.`}
						callback={() => {
							ObserverEmitter.emit(EVENTS.audiosEvents.controlVoices, voicesTypeControl.stop)
							setUiToShow(steps.win);
						}}
					></DialogBarNew>
				</>
			)}

			{uiToShow === steps.win && (
				<>
					<ValidationResultModal
						title="¡Bien hecho!"
						dialogModal="Ahora conoces los requisitos para realizar una venta responsable."
						buttonTxt="Continuar"
						isCorrect={true}
						action={() => {
							dispatch(
								completeOneTask({
									idActivity: 1,
									pointsWin: 0,
									subtema: tasksId.tema7.activities.subtema1
								})
							);
							navigator("/home7/tema7/subtema1/activityTwo");
						}}
					/>
				</>
			)}
		</>
	)
}
